export const listType = [
  {
    name: '样式1',
    value: 'NewsOne',
  },
  {
    name: '样式2',
    value: 'NewsTwo',
  },
  {
    name: '样式3',
    value: 'NewsThree',
  },
  {
    name: '样式4',
    value: 'NewsFour',
  },
]
export const hyperLinksType = [
  {
    name: '跳转链接',
    value: 'URLHref',
  },
  {
    name: '嵌套展示',
    value: 'URLIframe',
  },
]

export const topicType = [
  {
    name: '样式1',
    value: 'HorizontalImageWall',
  },
  {
    name: '样式2',
    value: 'VerticalImageWall',
  },
]
export const videoType = [
  {
    name: '样式1',
    value: 'NewsVideo',
  },
  {
    name: '样式2',
    value: 'NewsVideoTwo',
  },
]

export const bannnerType = [
  {
    name: '横向',
    value: 'BannerLong',
  },
  {
    name: '纵向',
    value: 'BannerShort',
  },
]
export const imageFitType = [
  {
    name: '拉伸铺满',
    value: 'fill',
  },
  {
    name: '等比缩放',
    value: 'contain',
  },
]
// 组件管理类型
export const dropdownComponent = [
  {
    value: 0,
    label: 'banner',
  },
  {
    value: 1,
    label: '飘窗',
  },
  {
    value: 2,
    label: '轮播图',
  },
  {
    value: 3,
    label: '专题',
  },
  {
    value: 4,
    label: '超链接',
  },
]
// 信息发布模块
export const informationPublishMap = {
  column: {
    columnText: 1, // 文字栏目
    columnImgText: 2, // 图文栏目
    columnVideo: 3, // 视频栏目
    columnFromThird: 2, // 外网栏目
  },
  columnSource: {
    columnFromThird: 2, // 外网栏目
  },
  component: {
    banner: dropdownComponent[0].value, // banner
    popup: dropdownComponent[1].value, // 飘窗
    carouse: dropdownComponent[2].value, // 轮播图
    topic: dropdownComponent[3].value, // 专题
    hyperlink: dropdownComponent[4].value, // 超链接
  },
}
// 应用系统登录方式
export const loginType = [
  {
    value: 0,
    label: '直接跳转',
  },
  {
    value: 3,
    label: 'auth2.0',
  },
  {
    value: 1,
    label: '账号登录',
    sso: true,
  },
  {
    value: 2,
    label: '账号密码登录',
    password: true,
    sso: true,
  },
]
// 应用系统请求方式 val 为2 则无需请求方式
export const postType = [
  {
    value: 0,
    label: 'get',
  },
  {
    value: 1,
    label: 'post',
  },
  {
    value: 2,
    label: 'form表单get提交',
  },
  {
    value: 3,
    label: 'form表单post提交',
  },
]
// 布局方式
export const layoutTypeData = [
  {
    value: 0,
    label: '自定义布局',
  },
  // {
  //   value: 1,
  //   label: '自动布局',
  // },
]
// 门户布局组件类型
export default [
  // {
  //   name: '导航栏',
  //   code: 'E001',
  //   config: {
  //     componentName: 'NavigationBar',
  //     configName: 'NavigationBarConfig',
  //     isDraggable: false,
  //     w: 1180,
  //     h: 1,
  //   }
  // },
  {
    name: '列表',
    code: 'E001',
    config: {
      componentName: 'NewsTwo',
      configName: 'NewsConfig',
      isDraggable: true,
      isResizable: true,
      w: 380,
      h: 200,
    },
  },
  {
    name: '飘窗',
    code: 'E002',
    config: {
      componentName: 'BayWindow',
      configName: 'BayWindowConfig',
      isDraggable: true,
      isResizable: true,
      w: 380,
      h: 200,
      type: 1,
    },
  },
  {
    name: '超链接',
    code: 'E003',
    config: {
      componentName: 'URLHref',
      configName: 'HyperLinksConfig',
      isDraggable: true,
      isResizable: true,
      w: 1180,
      h: 100,
      type: 4,
    },
  },
  {
    name: '专题',
    code: 'E004',
    config: {
      componentName: 'HorizontalImageWall',
      configName: 'TopicConfig',
      isDraggable: true,
      isResizable: true,
      w: 380,
      h: 240,
      type: 3,
    },
  },
  {
    name: '轮播图',
    code: 'E005',
    config: {
      componentName: 'Carousel',
      configName: 'CarouselConfig',
      isDraggable: true,
      isResizable: true,
      w: 380,
      h: 240,
      type: 2,
    },
  },
  {
    name: '滚动图窗',
    code: 'E006',
    config: {
      componentName: 'ImageNewsTwo',
      configName: 'ImageNewsConfig',
      isDraggable: true,
      isResizable: true,
      w: 760,
      h: 240,
      type: 2,
    },
  },
  {
    name: '视频列表',
    code: 'E007',
    config: {
      componentName: 'NewsVideo',
      configName: 'NewsVideoConfig',
      isDraggable: true,
      isResizable: true,
      w: 760,
      h: 240,
      type: 3,
    },
  },
  {
    name: '图片列表',
    code: 'E008',
    config: {
      componentName: 'ImageNews',
      configName: 'NewsImageConfig',
      isDraggable: true,
      isResizable: true,
      w: 760,
      h: 240,
      type: 2,
    },
  },
  {
    name: 'html',
    code: 'E010',
    config: {
      componentName: 'NewsHtml',
      configName: 'NewsHtmlConfig',
      isDraggable: true,
      isResizable: true,
      w: 1180,
      h: 350,
      type: 1,
    },
  },
  {
    name: 'banner',
    code: 'E009',
    config: {
      componentName: 'BannerLong',
      configName: 'BannerConfig',
      isDraggable: true,
      isResizable: true,
      w: 1180,
      h: 150,
      type: 0,
    },
  },
  {
    name: '面包屑导航',
    code: 'E0010',
    config: {
      componentName: 'Breadcrumb',
      configName: '',
      isDraggable: true,
      isResizable: true,
      w: 1180,
      h: 18,
    },
  },
]
